import React from "react";
import { CAseimages, Coverdkava, Coverelemnt, Innsightimagedkava, Innsightimageelemnt, Momocase, Momocover } from "../../components/IconsImport";
import { useNavigate } from "react-router-dom";
import { useCaseStudy } from "../../components/customHooks/customHook";

const CaseStudiesCards = () => {
  const navigate = useNavigate();
  // const handleCardClick = (title) => {
  //   navigate(`/case-studies-inner/${title}`);
  // };
  const handleCardClick = (title, id) => {
    let slug;
    if (title === "How GoPappe Amped Up Its Social Growth Via Influencer Campaigns") {
      slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') 
        .replace(/(^-|-$)+/g, '');  
      window.location.href = `/case-studies/gopappe/${slug}`;
    } else if (title === "Tapping Into Lifestyle Influencers To Drive Jaw-Dropping Impact For DKava Decor") {
      slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') 
        .replace(/(^-|-$)+/g, '');  
      window.location.href = `/case-studies/dkava/${slug}`;
    }
     else if (title === "How Elemnt Increased Its Brand Visibility By 120% On E-Commerce Marketplaces") {
      slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') 
        .replace(/(^-|-$)+/g, '');  
      window.location.href = `/case-studies/elemnt/${slug}`;
    }
     else if (title === "How Influencer Campaigns Lit Up Momomia’s Hype By 2X") {
      slug = title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') 
      .replace(/(^-|-$)+/g, '');  
    window.location.href = `/case-studies/momomia/${slug}`;
      // navigate(`/case-studies/${id}`);
    }
  }
  
  const caseStudiesData = [
    {
      _id: "65aa4badd2fe5c4992081d63",
      title: "How GoPappe Amped Up Its Social Growth Via Influencer Campaigns",
      coverImage: {
        image: "1705659309229-268845077-casefirst.dc9fa0a2e1bc30b0c353.png",
        imageUrl:CAseimages
          ,
      },
      caseType: "FOOD & LIFESTYLE",
    },
    {
      _id: "65aa4badd2fe5c4992081d64",
      title: "How Influencer Campaigns Lit Up Momomia’s Hype By 2X",
      coverImage: {
        image: "1705659309229-268845077-casefirst.dc9fa0a2e1bc30b0c353.png",
        imageUrl:Momocover,
      },
      caseType: "FOOD & LIFESTYLE",
    },
    {
      _id: "65aa4badd2fe5c4992081d65",
      title: "Tapping Into Lifestyle Influencers To Drive Jaw-Dropping Impact For DKava Decor",
      coverImage: {
        image: "1705659309229-268845077-dkava.dc9fa0a2e1bc30b0c353.png",
        imageUrl:Coverdkava,
      },
      caseType: "DECOR & GIFTS",
    },
    {
      _id: "65aa4badd2fe5c4992081d65",
      title: "How Elemnt Increased Its Brand Visibility By 120% On E-Commerce Marketplaces",
      coverImage: {
        image: "1705659309229-268845077-dkava.dc9fa0a2e1bc30b0c353.png",
        imageUrl:Coverelemnt,
      },
      caseType: "E-COMMERCE",
    },

  ];
  return (
    <>
      {caseStudiesData.map((data, index) => (
        <div
          className="case_card_conatiner"
          key={index}
          onClick={() => handleCardClick(data.title, data._id)}
        >
          <div className="case_images">
            <img src={data.coverImage.imageUrl} alt="case images" />
          </div>
          <div className="case_sub_container">
            <ul>
              <li>
                <p className="case_category">{data.caseType}</p>
              </li>
              <li>
                <h1 className="case_title">{data.title}</h1>
              </li>
              {/* <li><h4 className="case_by">By {data.author}</h4></li>
              <li><h6 className="case_by_date">{data.date}</h6></li> */}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default CaseStudiesCards;
